import { EventType, type IPublicClientApplication } from "@azure/msal-browser";

export const AUTH_ORIGIN_COOKIE = "labpro_auth_origin";

export async function saveOriginForLoginHost(loginHostUri: string) {
  await cookieStore.set({
    name: AUTH_ORIGIN_COOKIE,
    value: window.location.origin,
    domain: new URL(loginHostUri).hostname.split(".").slice(1).join("."),
    path: "/",
    sameSite: "none",
  });
}

export function rememberOriginForSilentRenewal(
  instance: Pick<IPublicClientApplication, "addEventCallback">,
  loginHostUri: string,
) {
  instance.addEventCallback((event) => {
    if (event.eventType === EventType.ACQUIRE_TOKEN_NETWORK_START) {
      void saveOriginForLoginHost(loginHostUri);
    }
  });
}
